export default {"src":"/_next/static/media/car50_64.85562370.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};